import {
  Wifi as WifiIcon,
  Pool as PoolIcon,
  FitnessCenter as FitnessCenterIcon,
  LocalLaundryService as LaundryIcon,
  DirectionsCar as ParkingIcon,
  Kitchen as KitchenIcon,
  Tv as TvIcon,
  AcUnit as AcIcon,
  Elevator as ElevatorIcon,
  Lock as SecurityIcon,
  LocalCafe as CafeIcon,
  Restaurant as RestaurantIcon,
  Pets as PetsIcon,
} from '@mui/icons-material';

import StarBorderIcon from "@mui/icons-material/StarBorder";
import CategoryIcon from "@mui/icons-material/Category";
import ExtensionIcon from "@mui/icons-material/Extension";
import AppsIcon from "@mui/icons-material/Apps";
import BuildIcon from "@mui/icons-material/Build";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import StarsIcon from "@mui/icons-material/Stars";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";

const defaultAmenities = [
  { id: 'wifi', label: 'WiFi', icon: <WifiIcon fontSize="large" /> },
  { id: 'pool', label: 'Pool', icon: <PoolIcon fontSize="large" /> },
  { id: 'gym', label: 'Gym', icon: <FitnessCenterIcon fontSize="large" /> },
  { id: 'laundry', label: 'Laundry', icon: <LaundryIcon fontSize="large" /> },
  { id: 'parking', label: 'Parking', icon: <ParkingIcon fontSize="large" /> },
  { id: 'kitchen', label: 'Kitchen', icon: <KitchenIcon fontSize="large" /> },
  { id: 'tv', label: 'TV', icon: <TvIcon fontSize="large" /> },
  { id: 'ac', label: 'AC', icon: <AcIcon fontSize="large" /> },
  { id: 'elevator', label: 'Elevator', icon: <ElevatorIcon fontSize="large" /> },
  { id: 'security', label: 'Security', icon: <SecurityIcon fontSize="large" /> },
  { id: 'cafe', label: 'Cafe', icon: <CafeIcon fontSize="large" /> },
  { id: 'restaurant', label: 'Restaurant', icon: <RestaurantIcon fontSize="large" /> },
  { id: 'pets', label: 'Pet Friendly', icon: <PetsIcon fontSize="large" /> },
];

export default defaultAmenities;

export const customIcons = [
  <StarBorderIcon fontSize="large" />,
  <CategoryIcon fontSize="large" />,
  <ExtensionIcon fontSize="large" />,
  <AppsIcon fontSize="large" />,
  <BuildIcon fontSize="large" />,
  <EmojiObjectsIcon fontSize="large" />,
  <LightbulbIcon fontSize="large" />,
  <WhatshotIcon fontSize="large" />,
  <StarsIcon fontSize="large" />,
  <LocalOfferIcon fontSize="large" />,
];
